import { render, staticRenderFns } from "./RentalBoxOnHand.vue?vue&type=template&id=2e38d2ac&scoped=true&"
import script from "./RentalBoxOnHand.vue?vue&type=script&lang=js&"
export * from "./RentalBoxOnHand.vue?vue&type=script&lang=js&"
import style0 from "./RentalBoxOnHand.vue?vue&type=style&index=0&id=2e38d2ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38d2ac",
  null
  
)

export default component.exports